import Model from "./Model";
import React from "react";
import { useParams } from "react-router-dom";

const ModelManagement: React.FC = () => {
  const { model } = useParams<{ model: string }>();
  return <Model key={model} />;
};
export default ModelManagement;
